import { Styles } from "../../config"

const styles = {
	accordionContainer: {
		width: "100%",
		padding: "0px 10px",
		border: "1px solid #acbee8",
		borderRadius: "10px !important",
		"&::before": { display: "none" }
	},

	accordionIcon: {
		color: Styles.Color.primary
	}
}

export default styles
